export const ACTIVITY_LABELS: Record<string, string> = {
    file_upload: 'Fájl feltöltés',
    file_rename: 'Fájl átnevezés',
    file_move: 'Fájl áthelyezés',
    file_copy: 'Fájl másolás',
    file_delete: 'Fájl törlés',
    file_download: 'Fájl letöltés',
    file_scanned: 'Fájl ellenőrzés',
    file_infected: 'Fertőzött fájl',
    file_linked: 'Fájl linkelés',
    file_unlinked: 'Link megszüntetése',
    directory_create: 'Mappa létrehozás',
    directory_rename: 'Mappa átnevezés',
    directory_move: 'Mappa áthelyezés',
    directory_delete: 'Mappa törlés',
};

export function activityLabel(value: string | null | undefined): string {
    if (!value) return '';
    return ACTIVITY_LABELS[value.toLowerCase().trim()] ?? value;
}

const ACTIVITY_SENTENCES: Record<string, { active: string; passive: string; noun: 'fájl' | 'mappa' }> = {
    file_upload: { active: 'feltöltötte', passive: 'feltöltve', noun: 'fájl' },
    file_rename: { active: 'átnevezte', passive: 'átnevezve', noun: 'fájl' },
    file_move: { active: 'áthelyezte', passive: 'áthelyezve', noun: 'fájl' },
    file_copy: { active: 'lemásolta', passive: 'lemásolva', noun: 'fájl' },
    file_delete: { active: 'törölte', passive: 'törölve', noun: 'fájl' },
    file_download: { active: 'letöltötte', passive: 'letöltve', noun: 'fájl' },
    file_scanned: { active: 'ellenőrizte', passive: 'ellenőrizve', noun: 'fájl' },
    file_infected: { active: 'fertőzöttként jelölte', passive: 'fertőzöttként megjelölve', noun: 'fájl' },
    file_linked: { active: 'linkelte', passive: 'linkelve', noun: 'fájl' },
    file_unlinked: { active: 'leválasztotta', passive: 'leválasztva', noun: 'fájl' },
    directory_create: { active: 'létrehozta', passive: 'létrehozva', noun: 'mappa' },
    directory_rename: { active: 'átnevezte', passive: 'átnevezve', noun: 'mappa' },
    directory_move: { active: 'áthelyezte', passive: 'áthelyezve', noun: 'mappa' },
    directory_delete: { active: 'törölte', passive: 'törölve', noun: 'mappa' },
};

function definiteArticle(word: string): string {
    const first = word.trim().toLowerCase().charAt(0);
    return 'aáeéiíoóöőuúüű'.includes(first) ? 'az' : 'a';
}

interface ActivityLocation {
    path?: string | null;
    name?: string | null;
}

interface ActivityDescriptionContext {
    event?: string | null;
    subject?: { name?: string | null } | null;
    causer?: { name?: string | null } | null;
    properties?: { from?: ActivityLocation | null; to?: ActivityLocation | null } | Record<string, unknown> | null;
}

const MOVE_LIKE_EVENTS = new Set(['file_move', 'directory_move', 'file_copy']);

function folderPhrase(path: string | null | undefined, suffix: 'ból' | 'ba'): string {
    const p = (path ?? '').trim();
    if (p === '') return suffix === 'ból' ? 'a gyökérmappából' : 'a gyökérmappába';
    return `${definiteArticle(p)} '${p}' mappá${suffix}`;
}

export function activityDescription(entry: ActivityDescriptionContext | null | undefined): string {
    const event = entry?.event?.toLowerCase().trim();
    if (!event) return '';

    const def = ACTIVITY_SENTENCES[event];
    const causer = entry?.causer?.name?.trim();
    const subject = entry?.subject?.name?.trim();

    if (!def) {
        return causer ? `${causer}: ${activityLabel(event)}` : activityLabel(event);
    }

    const nounAccusative = def.noun === 'fájl' ? 'fájlt' : 'mappát';

    let movement = '';
    if (MOVE_LIKE_EVENTS.has(event)) {
        const props = entry?.properties as { from?: ActivityLocation | null; to?: ActivityLocation | null } | undefined;
        if (props?.from || props?.to) {
            movement = ` ${folderPhrase(props.from?.path, 'ból')} ${folderPhrase(props.to?.path, 'ba')}`;
        }
    }

    if (subject) {
        const article = definiteArticle(subject);
        if (causer) {
            return `${causer} ${def.active} ${article} '${subject}' ${nounAccusative}${movement}`;
        }
        const articleCap = article.charAt(0).toUpperCase() + article.slice(1);
        return `${articleCap} '${subject}' ${def.noun} ${def.passive}${movement}`;
    }

    return causer ? `${causer} – ${activityLabel(event)}` : `Egy ${def.noun} ${def.passive}`;
}



